// * Extends the default bootstrap collapse functionality to support teaser view
const collapse_triggers = document.querySelectorAll(".collapse-trigger");

collapse_triggers.forEach((item) => {
  item.addEventListener("click", (event) => {
    event.target.classList.toggle("collapse-trigger--active");

    if (document.documentElement.lang == "nb") {
      if (!event.target.classList.contains("collapse-trigger--active")) {
        event.target.innerText = "Vis mer";
      } else {
        event.target.innerText = "Vis mindre";
      }
    } else {
      if (!event.target.classList.contains("collapse-trigger--active")) {
        event.target.innerText = "Show more";
      } else {
        event.target.innerText = "Show less";
      }
    }
  });
});
